// Katalog "Boyutları yönet" düğmesi + penceresi (TODO-KPI-146): özel boyut sözlüğünü yükler,
// düzenle/sil sonrası önbelleği geçersiz kılar (sonraki Kırılım penceresi taze listeyi çeker).

import { useEffect, useState } from "react";
import { deleteKpiBreakdownDimension, updateKpiBreakdownDimension } from "../../api/kpi";
import { KPI_BREAKDOWN_COPY } from "../../lib/kpi-breakdown-copy";
import { dimensionManageError } from "../../lib/kpi-breakdown-dimension-manage";
import { useKpiBreakdownDimensionsStore } from "../../stores/kpi-breakdown-dimensions-store";
import { BreakdownDimensionsPanel } from "./BreakdownDimensionsPanel";
import { KpiModal } from "./KpiModal";
import { btnGhost } from "./kpi-form-styles";

const C = KPI_BREAKDOWN_COPY.dimensions;

export function CatalogDimensionsButton(props: {
  onFlash: (message: string) => void;
}): JSX.Element {
  const [open, setOpen] = useState(false);
  const custom = useKpiBreakdownDimensionsStore((s) => s.custom);
  const load = useKpiBreakdownDimensionsStore((s) => s.load);
  const invalidate = useKpiBreakdownDimensionsStore((s) => s.invalidate);

  useEffect(() => {
    if (open) void load(true);
  }, [open, load]);

  return (
    <>
      <button
        type="button"
        style={btnGhost}
        data-testid="kpi-catalog-dimensions-open"
        onClick={() => setOpen(true)}
      >
        {C.open}
      </button>
      {open ? (
        <KpiModal open kicker={C.kicker} title={C.title} width={640} onClose={() => setOpen(false)}>
          <BreakdownDimensionsPanel
            dimensions={custom}
            onSave={async (slug, patch) => {
              try {
                await updateKpiBreakdownDimension(slug, patch);
                invalidate();
                await load(true);
                props.onFlash(C.saved);
                return null;
              } catch (err) {
                return dimensionManageError(err);
              }
            }}
            onDelete={async (slug) => {
              try {
                await deleteKpiBreakdownDimension(slug);
                invalidate();
                await load(true);
                props.onFlash(C.removed);
                return null;
              } catch (err) {
                return dimensionManageError(err);
              }
            }}
          />
        </KpiModal>
      ) : null}
    </>
  );
}
